<template>
  <div class="ws-request-exams">
    <ws-date-filter
      :date.sync="date"
      @change="onDateFilter"
    />
    <ws-request-exams-filter
      ref="filter"
      @change="onFilter"
    />
    <section class="ws-request-exams__content">
      <ws-list-view
        class="ws-request-exams-table is-table is-small"
        :class="{ 'is-pending':isPending, 'is-loading':isFindPending }"
        :bordered="true"
        :data="list"
        :header="true"
        :skeleton="isPending"
        :detailed="true"
        :opened-detailed="expandedItems"
        :columns="columns"
      >
        <template
          slot="empty"
          v-if="isFilterEnabled"
        >{{$t('Результатов, подходящих под выбранные фильтры не найдено.')}}
          <a
            href=""
            @click.prevent="disableFilters()"
          >{{$t('Отключить фильтры')}}</a>
        </template>
        <template slot-scope="props">
          <ws-list-view-item-column data-id="exam-flags-names-column">
            <div class="is-fullwidth">
              <div class="tags is-marginless">
                <template v-for="(flag, index) in getFlags(props.row.flags)">
                  <span
                    class="tag is-violet exam-flag is-radiusless"
                    :class="flag"
                    :key="index"
                    v-text="$t(`exam.flags.${flag}`)"
                    :title="$t(`exam.flags.${flag}`)"
                  >
                  </span>
                </template>
              </div>
              <span style="display: none">{{JSON.stringify(props.row.flags)}}</span>
              <span
                class="is-size-4"
                data-id="exam-names"
              ><strong>ID {{props.row.human_readable_id}}</strong> | {{props.row.name.display}}</span>
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div class="is-fullwidth has-text-centered">
              <ws-time-formatter
                data-id="day-cm1-column"
                class="is-size-4"
                :date="props.row.day_cm1"
              />
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div class="is-fullwidth has-text-centered">
              <ws-time-formatter
                data-id="created-at-column"
                class="is-size-4"
                :date="props.row.created_at"
              />
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div
              class="is-fullwidth"
              v-if="props.row.accred_comps.competency"
              data-id="competency-column"
            >
              <span
                data-id="competency-has-text-danger"
                class="has-text-danger"
                v-if="!isHasCod(props.row)"
              >{{$t('КОД отсутствует')}}<br></span>
              <strong
                data-id="competency-code"
                v-if="props.row.accred_comps.competency.code"
              >{{props.row.accred_comps.competency.code}}<br></strong>
              <span
                data-id="competency-name-display"
                v-text="props.row.accred_comps.competency.name.display"
              ></span>
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div
              class="is-fullwidth"
              data-id="workers-column"
            >
              <span v-if="props.row.accred_comps.workers">
                <strong>{{ props.row.accred_comps.workers }}</strong> /
              </span>
              <span
                data-id="workers-name-display"
                class=""
              >
                <ws-icon
                  v-if="!props.row.de_center.visible"
                  name="minus-circle"
                  width="12"
                  height="12"
                  class="minus-circle-ico"
                />
                {{ props.row.de_center.name.display }}
              </span><br>
              <span v-if="props.row.de_center.address">
                <span v-if="props.row.de_center.address.locality">{{ props.row.de_center.address.locality.title.display }}<br></span>
                {{ props.row.de_center.address.address.display }}
              </span>
              <ws-curator-list :curators="curators[props.row.de_center.parent.guid]"/>
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <div data-id="complexity-level-column">
              <div
                class="is-fullwidth"
                v-if="props.row.accred_comps.complexity_level"
              >
                <span
                  class=""
                  v-text="props.row.accred_comps.complexity_level"
                ></span>
              </div>
              <ws-accreditation :accred_comps="props.row.accred_comps" :exam="props.row" />
            </div>
          </ws-list-view-item-column>
          <ws-list-view-item-column>
            <span
              data-id="status-column"
              class="has-text-success"
              :class="{'has-text-danger': props.row.status === constants.request_exams_status.REVISION_AUTH_ORG
              || props.row.status === constants.request_exams_status.REVISION_DE_DEPARTMENT}"
              v-text="$t(`exam_request.status.${props.row.status}`)"
            >
            </span>
          </ws-list-view-item-column>
          <ws-list-view-item-column data-id="actions-column">
            <div class="is-fullwidth has-text-right">
              <ws-permission-node
                :resources="['services/de/demoexam']"
                :actions="['update']"
                effect="display"
              >
                <b-tooltip
                  :label="$t('Редактировать')"
                  type="is-dark"
                >
                  <button
                    class="button is-text"
                    data-id="edit-button"
                    @click="editItem(props.row)"
                    :disabled="isDisableForRole(props.row.status)"
                    :aria-label="$t('Редактировать')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="edit"
                      color="#6D9AE8"
                      :fill="false"
                      width="14"
                      height="14"
                    />
                  </button>
                </b-tooltip>
              </ws-permission-node>
              <ws-permission-node
                :resources="['services/de/demoexam']"
                :actions="['create']"
                effect="display"
              >
                <b-tooltip
                  :label="$t('Сделать копию')"
                  type="is-dark"
                >
                  <button
                    class="button is-text"
                    data-id="copy-button"
                    :disabled="isCloning(props.row)"
                    @click="cloneItem(props.row)"
                    :aria-label="$t('Сделать копию')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="copy"
                      color="#6D9AE8"
                      :fill="false"
                      width="14"
                      height="14"
                    />
                  </button>
                </b-tooltip>
              </ws-permission-node>
              <ws-permission-node
                :resources="['services/de/demoexam']"
                :actions="['delete']"
                effect="display"
              >
                <b-tooltip
                  :label="$t('Удалить')"
                  type="is-danger"
                >
                  <button
                    class="button is-text"
                    data-id="trash-button"
                    :disabled="isDisableForRole(props.row.status) || isDeleting(props.row)"
                    @click="removeItem(props.row)"
                    :aria-label="$t('Удалить')"
                  >
                    <ws-icon
                      class="ws-button__icon"
                      name="trash"
                      color="#6D9AE8"
                      :fill="false"
                      width="14"
                      height="14"
                    />
                  </button>
                </b-tooltip>
              </ws-permission-node>
            </div>
          </ws-list-view-item-column>
        </template>
        <template
          slot="details"
          slot-scope="props"
        >
          <ws-exams-shifts-list
            :exam.sync="props.row"
            :items="props.row.shifts"
            @shifts-updated="fetchAfterShiftUpdate"
          />
        </template>
        <template slot="skeleton">
          <ws-list-view-skeleton-item
            :height="'39px'"
            :boxCount="1"
            :boxHeights="['38px']"
          />
          <ws-list-view-skeleton-item
            :height="'80px'"
            :boxCount="4"
            :boxHeights="['25px', '25px', '25px', '25px']"
          />
          <ws-list-view-skeleton-item
            :height="'80px'"
            :boxCount="4"
            :boxHeights="['25px', '25px', '25px', '25px']"
          />
        </template>
      </ws-list-view>
    </section>
    <footer class="ws-request-exams__footer">
      <ws-pagination
        data-id="ws-pagination-component"
        @change="onPageChange"
        :align="'right'"
        :totalItems="pagination.total"
        :itemsPerPage="pagination.per_page"
        :disabled="isPending"
        :currentIndex="pagination.current_page - 1"
      >
      </ws-pagination>
    </footer>
  </div>
</template>

<script>
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex'
import WsRequestExamsForm from '@/components/de/request-exams/modals/WsRequestExamsForm'
import { constants } from '@/services/constants.service'
import examsListMixin from '@/mixins/exams-list.mixin'
import WsAccreditation from '@/components/de/de-center/WsAccredidation'
import { isDeCenterAccredited } from '@/utils/isDeCenterAccreditated'

export default {
  name: 'WsRequestExamsTable',
  components: { WsAccreditation },
  mixins: [examsListMixin],
  data () {
    return {
      expandedItems: [],
      columns: [
        {
          field: 'name.display',
          label: 'Название экзамена',
          sortable: true
        },
        {
          field: 'submitted_at',
          label: 'День ПД',
          sortable: true
        },
        {
          field: 'created_at',
          label: 'Дата создания',
          sortable: true
        },
        {
          field: 'Профессия/специальность (ДЭ)',
          label: 'Профессия/специальность (ДЭ)'
        },
        {
          label: 'Рабочие места / ЦПДЭ'
        },
        {
          field: 'code',
          label: 'Обследование'
        },
        {
          field: 'status',
          label: 'Статус'
        },
        {
          label: 'Действия'
        }
      ],
      constants,
      ready: 0,
      flags: '',
      cloningItems: [],
      deletingItems: [],
      curators: []
    }
  },
  watch: {
    ready (value) {
      if (value > 0) {
        this._fetch()
      }
    }
  },
  computed: {
    ...mapState('exams', {
      isFindPending: 'isFindPending',
      pagination: 'pagination'
    }),
    ...mapState('authentication', ['currentRole']),
    ...mapGetters('exams', {
      list: 'list'
    }),
    isPending () {
      return this.isFindPending && this.list.length === 0
    },
    isDisabledDateFilter () {
      return this.isFindPending || !!(this.filter && this.filter.humanreadble)
    }
  },
  methods: {
    ...mapActions('exams', ['find', 'remove', 'create']),
    ...mapActions('refbook/curators', {
      'findCurators': 'create'
    }),
    ...mapMutations('exams', ['clearAll', 'clearList']),
    isCloning (item) {
      return this.cloningItems.indexOf(item.guid) > -1
    },
    isDeleting (item) {
      return this.deletingItems.indexOf(item.guid) > -1
    },
    isHasCod (exam) {
      if (exam.accred_comps && exam.accred_comps.competency && exam.accred_comps.competency.complexity_level && exam.accred_comps.competency.complexity_level.length) {
        return exam.accred_comps.competency.complexity_level.indexOf(exam.accred_comps.complexity_level) > -1
      } else {
        return false
      }
    },
    isDisableForRole (status) {
      return (this.currentRole === 'front_curator' &&
      !([this.constants.request_exams_status.NEW, this.constants.request_exams_status.REVISION_AUTH_ORG].includes(status))) ||
      (this.currentRole === 'front_rcc' &&
      ([this.constants.request_exams_status.REVIEW_DE_DEPARTMENT, this.constants.request_exams_status.AGREED_DE_DEPARTMENT].includes(status)))
    },
    async onDate () {
      await this._fetch()
    },
    async _fetch () {
      this.clearAll()
      try {
        if (!this.filter.exam_status) {
          Object.assign(this.filter, {
            exam_status: this.default_exam_status
          })
        }
        await this.find({
          query: this.filter.humanreadble
            ? {
              ...this.filter,
              flags: this.flags,
              page: this.page,
              per_page: this.per_page
            }
            : {
              ...this.filter,
              'day_cm1.from': this.date.from,
              'day_cm1.till': this.date.to,
              flags: this.flags,
              page: this.page,
              per_page: this.per_page
            }
        })
      } catch (e) {
        if (!e) {
          return
        }
        this.$buefy.toast.open({
          message: this.$t(`Что-то пошло не так. Попробуйте еще раз`),
          type: 'is-danger'
        })
      }
      const guids = this.list.map(item => item.de_center.parent.guid)
      if (guids.length > 0) {
        this.curators = await this.findCurators([ guids, '/list' ])
      }
    },
    async fetchAfterShiftUpdate () {
      const dates = this.filter.humanreadble ? {} : { 'day_cm1.from': this.date.from, 'day_cm1.till': this.date.to }
      await this.find({
        query: {
          ...this.filter,
          flags: this.flags,
          page: this.page,
          per_page: this.per_page,
          ...dates
        }
      })
    },
    removeItem (item) {
      this.$buefy.dialog.confirm({
        title: this.$t(`Вы действительно хотите удалить заявку «${item.name.display}»?`),
        cancelText: this.$t('Отмена'),
        confirmText: this.$t('Удалить'),
        type: 'is-danger',
        onConfirm: async () => {
          try {
            if (this.deletingItems.indexOf(item.guid) === -1) {
              this.deletingItems.push(item.guid)
            }
            await this.remove(item.guid)
            this.$buefy.toast.open({
              message: this.$t(`Заявка «${item.name.display}» была успешно удалена`),
              type: 'is-success'
            })
          } catch (e) {
            this.$buefy.toast.open({
              message: this.$t('Что-то пошло не так. Попробуйте еще раз'),
              type: 'is-danger'
            })
          } finally {
            this.deletingItems.splice(this.deletingItems.indexOf(item.guid), 1)
          }
        }
      })
    },
    async cloneItem (item) {
      try {
        if (this.cloningItems.indexOf(item.guid) === -1) {
          this.cloningItems.push(item.guid)
        }
        await this.create(item)
        this.$buefy.toast.open({
          message: this.$t(`Копия заявки «${item.name.display}» была успешно создана`),
          type: 'is-success'
        })
      } catch (e) {
        this.$buefy.toast.open({
          message: this.$t('Что-то пошло не так. Попробуйте еще раз'),
          type: 'is-danger'
        })
      } finally {
        this.cloningItems.splice(this.cloningItems.indexOf(item.guid), 1)
      }
    },
    editItem (item) {
      this.$buefy.modal.open({
        parent: this,
        component: WsRequestExamsForm,
        hasModalCard: true,
        props: {
          // TODO: Gennadiy Ukhanov should fix this
          item: JSON.parse(JSON.stringify(item))
        },
        canCancel: false,
        events: {
          'editExam': async exam => {
            await this._fetch()
          }
        }
      })
    },
    getFlags (flags) {
      if (flags) {
        let arr = flags.slice(0)
        let secondaryDegreeIndex = arr.indexOf('secondary_degree')
        if (secondaryDegreeIndex > -1) {
          arr.unshift(arr.splice(secondaryDegreeIndex, 1)[0])
        }
        let universityDegreeIndex = arr.indexOf('university_degree')
        if (universityDegreeIndex > -1) {
          arr.unshift(arr.splice(universityDegreeIndex, 1)[0])
        }

        let fgosIndex = arr.indexOf('state_standard')
        if (fgosIndex > -1) {
          arr.unshift(arr.splice(fgosIndex, 1)[0])
        }
        const notStateStandardIndex = arr.indexOf('not_state_standard')
        if (notStateStandardIndex > -1) {
          arr.splice(notStateStandardIndex, 1)
        }
        const regionalIndex = arr.indexOf('regional_exam')
        if (regionalIndex > -1) {
          arr.splice(regionalIndex, 1)
        }
        const remoteMainExpert = arr.indexOf('main_expert_is_remote')
        if (remoteMainExpert > -1) {
          arr.splice(remoteMainExpert, 1)
        }
        return arr
      }
    },
    isAcredentialled (item) {
      return isDeCenterAccredited(item)
    },
    isCanDelete (exam) {
      if (exam.status === constants.request_exams_status.AGREED_DE_DEPARTMENT) {
        return false
      }
      if (this.currentRole === 'front_rcc' && exam.status === constants.request_exams_status.REVISION_AUTH_ORG) {
        return true
      }
      if (
        (this.currentRole === 'front_rcc' ||
          this.currentRole === 'front_university' ||
          this.currentRole === 'front_curator' ||
          this.currentRole === 'front_curator_institution') &&
        exam.status !== constants.request_exams_status.NEW
      ) {
        return false
      }
      return true
    }
  },
  created () {
    this.default_exam_status = `${constants.request_exams_status.NEW},${constants.request_exams_status.REVIEW_AUTH_ORG},${constants.request_exams_status.REVISION_AUTH_ORG},${constants.request_exams_status.REVIEW_DE_DEPARTMENT},${constants.request_exams_status.REVISION_DE_DEPARTMENT},${constants.request_exams_status.AGREED_DE_DEPARTMENT}`
    switch (this.currentRole) {
      case 'front_50plus':
        this.flags = constants.exam_flags.FIFTY_PLUS
        break
      case 'front_mio':
        this.flags = constants.exam_flags.MPO
        break
      case 'front_university':
        this.flags = constants.exam_flags.VUZ
        break
      case 'front_me':
        this.flags = `${constants.exam_flags.VUZ},${constants.exam_flags.FIFTY_PLUS},${constants.exam_flags.MPO},${constants.exam_flags.REGIONAL}`
        break
      case 'front_dep':
        this.flags = `${constants.exam_flags.VUZ},${constants.exam_flags.REGIONAL}`
        break
      case 'front_admin':
        this.flags = `${constants.exam_flags.VUZ},${constants.exam_flags.REGIONAL},${constants.exam_flags.FIFTY_PLUS},${constants.exam_flags.MPO}`
        break
      case 'front_curator_institution':
        this.flags = `${constants.exam_flags.VUZ}`
        break
      default:
        this.flags = constants.exam_flags.REGIONAL
    }
    const unwatchFilter = this.$watch('filter', function () {
      this.ready++
      unwatchFilter()
    })
  }
}
</script>
